import { memo } from "react";
import PropTypes from "prop-types";
import { paymentTypeShape } from "app/utils/propTypes";
import { FormattedMessage } from "react-intl";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";
import "./PaymentDescriptionTerms.scss";
import PaymentModesTooltipContainer from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentModes/PaymentModesTooltipContainer";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const PaymentDescriptionTerms = ({
	availablePaymentTerms = [],
	availablePaymentMethods = [],
	enableDepositDisplay = false,
	isBookingDateEligibleForDeposit,
	onlinePercentage,
}) => {
	const paymentTerms = availablePaymentTerms?.map(availablePaymentTerm => {
		if (availablePaymentTerm !== 1) {
			return (
				<div className="payment-description-terms__item" key={availablePaymentTerm}>
					<FormattedMessage
						id="general.payment.term.short"
						values={{ term: availablePaymentTerm }}
					/>
				</div>
			);
		}
		return null;
	});

	const onlinePercentageValue = (
		<div className="payment-description-terms__item">
			<FormattedMessage
				id="payment.terms.description.payment.percentage"
				values={{
					percentage: onlinePercentage,
				}}
			/>
		</div>
	);
	const displayPaymentTerms =
		availablePaymentTerms.length > 1 &&
		(enableDepositDisplay ? isBookingDateEligibleForDeposit : true);

	return displayPaymentTerms ? (
		<Typography
			variant={TYPOGRAPHY_VARIANTS.SMALL}
			isBold
			className="payment-description-terms"
			data-testid="payment-description-terms"
			component={"div"}
		>
			<div className="payment-description-terms__label">
				<FormattedMessage
					id={
						enableDepositDisplay
							? "payment.terms.description.deposit.label"
							: "payment.terms.description.label"
					}
					values={{
						percentage: onlinePercentageValue,
						paymentTerms: <>{paymentTerms}</>,
					}}
				/>
			</div>

			<FloatingButton
				position="bottom"
				floatingContent={
					<PaymentModesTooltipContainer paymentModes={availablePaymentMethods} />
				}
				referenceComponent={<IconInfo width={12} height={12} />}
			/>
		</Typography>
	) : null;
};

PaymentDescriptionTerms.propTypes = {
	availablePaymentTerms: PropTypes.arrayOf(paymentTypeShape),
	availablePaymentMethods: PropTypes.array,
	enableDepositDisplay: PropTypes.bool,
	isBookingDateEligibleForDeposit: PropTypes.bool,
	onlinePercentage: PropTypes.number,
};
export default memo(PaymentDescriptionTerms);
